"use client";

import { useEffect, useRef, useState } from "react";
import { announce } from "@/lib/a11y/announce";

/** Copy a value, announce it, and report "copied" for a moment. A refused
 *  clipboard (insecure context, permission) stays silent: the value is still
 *  on screen and selectable. */
export function useCopy(value: string, announcement: string, ms = 1500) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      announce(announcement, "polite");
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), ms);
    } catch {
      // Nothing to do; see above.
    }
  };
  return { copied, copy };
}
